import type { PickTicketsItemCreateFormSchema } from './schema';

export const pickTicketsItemDefaultValues: Readonly<PickTicketsItemCreateFormSchema> = {
  pick_ticket_id: -1,
  inventory_and_kit: null,
  items: [],
} as const;

// const x = {
//   id: -1,
//   pick_ticket_id: -1,
//   inventory_id: -1,
//   quantity: 1,
//   inventory: null,
//   sort_order: 0,
// };
